<template>
  <div
    class="relative w-full cursor-pointer group hover:no-underline"
    @click="playVideo"
  >
    <div
      class="flex items-start flex-col w-full gap-4 group hover:bg-primary hover:bg-opacity-[0.12]"
    >
      <div class="w-full h-[152px] bg-gray-100 rounded-sm relative">
        <img
          :src="video.youtube_details.thumbnails.url"
          :alt="video.youtube_details.title"
          class="object-cover w-full h-full rounded-sm pointer-events-none"
        />
        <!-- <iframe
          :id="`yt_${video.id}_${video.youtube_details.id}`"
          :src="`https://www.youtube.com/embed/${video.youtube_details.id}?fs=0&autoplay=1&start=0&end=10&mute=1&controls=0&rel=0&modestbranding=1`"
          frameborder="0"
          class="w-full h-full"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        ></iframe> -->
        <div
          class="absolute inset-0 flex items-center justify-center group-hover:scale-110"
        >
          <YoutubeIcon class="w-auto h-7" />
        </div>
      </div>

      <div class="flex-1 w-full">
        <div
          class="flex flex-col items-center justify-center w-full gap-2 mt-1 text-sm font-replica-pro text-custom-gray-10"
        >
          <img
            src="~/assets/images/youtube.png"
            alt="youtube Icon"
            class="w-6 h-6"
          />
          <span class="text-custom-gray-10">
            {{ video.youtube_details.channelTitle }}
          </span>
        </div>
        <span
          class="flex items-center justify-center mt-1 text-base font-normal text-center text-white line-clamp-2 text-underline-offset md:text-base font-replica-pro min-h-12"
          v-text="video.youtube_details.title"
        />

        <div
          class="flex flex-row items-center justify-between w-full gap-2 mt-2 text-sm lowercase font-replica-pro text-custom-gray-10"
        >
          <span class="whitespace-nowrap">
            <img
              v-if="
                video.youtube_details.channel &&
                video.youtube_details.channel.thumbnails
              "
              :src="video.youtube_details.channel.thumbnails.url"
              :alt="video.youtube_details.channelTitle"
              class="w-7.5 h-7.5 rounded-full"
            />
          </span>
          <span
            class="flex-1 text-center uppercase whitespace-nowrap"
            v-text="video.youtube_details.friendly_published_at"
          >
          </span>
          <span @click.stop="onShare" class="flex w-7.5 h-7.5">
            <Share class="w-4 h-7.5" />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useModal } from "vue-final-modal";
import ShareContentModal from "~/modals/ShareContentModal.vue";

const Share = defineAsyncComponent(() =>
  import("@/assets/svg/share.svg?component")
);
const YoutubeIcon = defineAsyncComponent(() =>
  import("~/assets/svg/youtube.svg?component")
);

const props = defineProps({
  video: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits();

function playVideo() {
  emit("play", props.video);
}
// function autoPlayVideo() {
//   var iframe = document.querySelector(
//     `#yt_${props.video.id}_${props.video.youtube_details.id}`
//   );
//   var src = iframe.src;
//   iframe.src = src.replace("&autoplay=0", "&autoplay=1");
// }
// function autoPlayStopVideo() {
//   var iframe = document.querySelector(
//     `#yt_${props.video.id}_${props.video.youtube_details.id}`
//   );
//   var src = iframe.src;
//   iframe.src = src.replace("&autoplay=1", "&autoplay=0"); // This stops autoplay when the hover ends
// }
const { open, close } = useModal({
  component: ShareContentModal,
  attrs: {
    isChangeDir: true,
    video: props.video,
  },
});
const onShare = open;
</script>

<style>
.text-underline-offset {
  text-underline-offset: 4px;
}
</style>
